export default {"src":"/_next/static/media/spinner.03045ed3.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};